<template>
    <div class="user-cardreader">        
        <b-alert :variant="alertvariant" :show="dismissCountDown"
             dismissible             
             @dismissed="dismissCountDown=0"
             @dismiss-count-down="countDownChanged">
            <p>{{alerttxt}}</p>
            <b-progress :variant="alertvariant"
                  :max=5
                  :value="dismissCountDown"
                  height="4px">
            </b-progress>
        </b-alert>
        <b-form  v-on:submit.prevent="onSubmit" @reset="onReset">
            <b-form-group id="CardData"
                    label="Tarjeta de usuario:"
                    label-for="PosId"> 
            <b-form-input id="CardId"
                      type="password"
                      v-model="form.CardId"
                      required
                      placeholder="Pase su tarjeta de usuario...">
            </b-form-input>
             </b-form-group>
            <b-button type="submit" variant="primary">Aceptar</b-button>
            <b-button type="reset" variant="danger">Borrar Formulario</b-button>  
        </b-form> 
    </div>
</template>

<script>
var axios = require('axios')
import mixin from '@/components/mixin.js'

export default {
    mixins:[mixin],
    name: 'UserCardreader',
    data() {
        return {
            form: {
                CardId: ''                
            },
            alertvariant : "warning",             
            alerttxt: "",
            dismissCountDown : 0
        }
    },
    created: function () {
        if (localStorage.getItem('reqUserCard') == '0'){
            this.$store.commit('setUser', '1')
            this.setDefaultCust();
            this.$router.push('pos');    
        }
    },        
    methods: {
        onSubmit(evt) { 
            this.axios.post(this.ApiBaseUrl + 'possetup/SetUser',
                        JSON.stringify(this.form),
                        {headers: {"Content-Type": "application/json"}})            
            .then((response) => {        
                //this.options = response.data;
                var res = response.data.body;
                switch(res.return_value) {
                    case "0":
                        this.alertvariant = "danger"
                        this.alerttxt = "Tarjeta no reconocida";
                        break;
                    default:
                    this.alertvariant = "success"
                        this.alerttxt = "Tarjeta correcta";
                        this.$store.commit('setUser', res)
                        //this.$store.commit('setUser', res.salesperson)
                        this.setDefaultCust();
                        this.setDefaultSalesPerson(res.return_value);
                        this.$router.push('pos')                                           
                }               
                this.dismissCountDown = 5;          
                                   
                               
            })
            
        },
        countDownChanged (dismissCountDown) {
            this.dismissCountDown = dismissCountDown
        },
        onReset (evt) {
            evt.preventDefault();
            /* Reset our form values */
            this.form.PosId = '';
            this.form.Pwd = '';            
            /* Trick to reset/clear native browser form validation state */
            this.show = false;
            this.$nextTick(() => { this.show = true });
    }  
    }
}
</script>